import { render, staticRenderFns } from "./MaterialColors.vue?vue&type=template&id=08e2a316&scoped=true"
import script from "./MaterialColors.vue?vue&type=script&lang=js"
export * from "./MaterialColors.vue?vue&type=script&lang=js"
import style0 from "./MaterialColors.vue?vue&type=style&index=0&id=08e2a316&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e2a316",
  null
  
)

export default component.exports